import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { getPostAuthPath } from "../../utils/authRedirect";

/**
 * Guest-only pages (login, signup). Authenticated users are redirected during
 * render so the guest UI never flashes on a hard navigation / URL edit.
 */
export default function GuestOnlyRoute({ children }) {
  const loginToken = useSelector((state) => state.loginToken);
  const loginTokenCoUser = useSelector((state) => state.loginTokenCoUser);
  const redirectTo = getPostAuthPath(loginToken, loginTokenCoUser);

  if (redirectTo) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
}
